import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import State from "slotworks/state-machine/states/state";
import Point from "slotworks/utils/geom/point";

export default class RecoverStickySymbols extends State {
    public onEnter() {
        const record = GameState.getCurrentGame().getCurrentRecord();
        if (record instanceof SpinRecord) {
            const overlayGrid = record.overlayGrid;
            if (overlayGrid) {
                for (let reel = 0; reel < overlayGrid.length; reel++) {
                    for (let symbol = 0; symbol < overlayGrid[reel].length; symbol++) {
                        if (overlayGrid[reel][symbol]) {
                            const symbolId = overlayGrid[reel][symbol];
                            Components.matrix.addStuckSymbolById(new Point(reel + 1, symbol + 1), symbolId);
                        }
                    }
                }
            }
        }

        this.complete();
    }
}
